import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {CardMarkDto} from "../../common";

const sliceName = 'search';

export enum CardStateOption {
    All= "All",
    Known = "Known",
    Future = "Future",
    Memorizer = "Memorizer",
}

export enum GroupActionType {
    Delete = "Delete",
    MarkAsKnown = "MarkAsKnown",
    MarkAsFuture = "MarkAsFuture",
    MarkAsMemorizer = "MarkAsMemorizer",
}

export enum SearchItemType {
    Card = "Card",
}

export interface SearchItem {
    type: SearchItemType;
    id: string;
    title: string;
    subTitle: string;
    mark?: CardMarkDto;
}

interface SearchStore {
    text: string;
    tag: string;
    items: SearchItem[];
    cardState: CardStateOption;
    markedOnly: boolean;
    selectedIds: string[];
    isSelectionMode: boolean;
}

const initialState: SearchStore = {
    text: '',
    tag: '',
    items: [],
    cardState: CardStateOption.All,
    markedOnly: false,
    selectedIds: [],
    isSelectionMode: false,
}

const searchSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setText(state: SearchStore, action: PayloadAction<string>) {
            state.text = action.payload;
        },

        setTag(state: SearchStore, action: PayloadAction<string>) {
            state.tag = action.payload;
        },

        setCardState(state: SearchStore, action: PayloadAction<CardStateOption>) {
            state.cardState = action.payload;
        },

        setMarkedOnly(state: SearchStore, action: PayloadAction<boolean>) {
            state.markedOnly = action.payload;
        },

        markItem(state: SearchStore, action: PayloadAction<{cardId: string, mark: CardMarkDto}>) {
            const item = state.items.find(found => found.id === action.payload.cardId);
            if (item !== undefined) item.mark = action.payload.mark;
        },

        /** Unmarked cards leave the "marked" list, and lose their flag in any other list. */
        clearMarks(state: SearchStore, action: PayloadAction<string[]>) {
            const ids = new Set(action.payload);
            if (state.markedOnly) {
                state.items = state.items.filter(item => !ids.has(item.id));
                state.selectedIds = state.selectedIds.filter(id => !ids.has(id));
            } else {
                for (const item of state.items) {
                    if (ids.has(item.id)) delete item.mark;
                }
            }
        },

        put(state: SearchStore, action: PayloadAction<SearchItem[]>) {
            // Установка найденных элементов в стор
            state.items = action.payload;
        },
                
        // Новые действия для мультивыбора
        toggleSelectionMode(state: SearchStore) {
            state.isSelectionMode = !state.isSelectionMode;
            if (!state.isSelectionMode) {
                state.selectedIds = [];
            }
        },
        
        selectCard(state: SearchStore, action: PayloadAction<string>) {
            const cardId = action.payload;
            if (!state.selectedIds.includes(cardId)) {
                state.selectedIds.push(cardId);
            }
        },
        
        unselectCard(state: SearchStore, action: PayloadAction<string>) {
            const cardId = action.payload;
            state.selectedIds = state.selectedIds.filter(id => id !== cardId);
        },
        
        clearSelection(state: SearchStore) {
            state.selectedIds = [];
            state.isSelectionMode = false;
        },
        
        selectAll(state: SearchStore) {
            state.selectedIds = state.items.map(item => item.id);
        },
    }
});

export const searchActions = {
    ...searchSlice.actions,
}

export const searchReducer = searchSlice.reducer;